import styled from 'styled-components';

export const CustomVideo = styled.video`
  width: 250px;
  height: 150px;
`;
